import PropTypes from 'prop-types'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { itemPath, itemsProgress, sectionItems } from '../../../utility/coachCertification'
import ProgressBar from './ProgressBar'

import classes from './SectionRow.module.scss'

const statusKey = ({ done, total, available }) => {
  if (total > 0 && done === total) { return 'completed' }
  if (done > 0) { return 'inProgress' }

  return available ? 'notStarted' : 'locked'
}

const SectionRow = ({ section, finalQuiz, number, items }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const own = section ? sectionItems(items, section) : items.filter(item => item.final)
  const progress = itemsProgress(own)
  const status = statusKey(progress)
  const target = own.find(item => !item.done && item.available) || own.find(item => item.available || item.done)
  const lessons = section ? section.lessons.length : 0
  const quiz = section ? section.quiz : finalQuiz
  const quizMeta = quiz && t('portal.certification.item.quizMeta', { questions: quiz.questions.length, passMark: quiz.passMark })

  return (
    <button
      type='button'
      className={classNames('d-flex align-items-center text-left', classes.row)}
      onClick={() => navigate(itemPath(target))}
      disabled={!target}
    >
      <span className={classNames('d-flex align-items-center justify-content-center', classes.number, classes[status])}>
        {status === 'locked' ? <i className='fa fa-lock' aria-hidden='true' /> : number}
      </span>
      <span className='flex-grow-1 min-w-0'>
        <span className='d-flex align-items-center flex-wrap'>
          <span className={classes.title}>{section ? section.title : t('portal.certification.item.finalExam')}</span>
          <span className={classNames(classes.badge, classes[`badge${status}`])}>{t(`portal.certification.sections.status.${status}`)}</span>
        </span>
        <span className={classes.meta}>
          {section && t('portal.certification.details.lessons', { count: lessons })}
          {section && quiz && ' · '}
          {quiz && `${t('portal.certification.details.quiz')} · ${quizMeta}`}
        </span>
      </span>
      <ProgressBar done={progress.done} total={progress.total} className={classes.progress} />
      <i className={classNames('fa fa-chevron-right', classes.chevron)} aria-hidden='true' />
    </button>
  )
}

SectionRow.propTypes = {
  section: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    lessons: PropTypes.array.isRequired,
    quiz: PropTypes.shape({ questions: PropTypes.array.isRequired, passMark: PropTypes.number.isRequired }),
  }),
  finalQuiz: PropTypes.shape({ questions: PropTypes.array.isRequired, passMark: PropTypes.number.isRequired }),
  number: PropTypes.number.isRequired,
  items: PropTypes.array.isRequired,
}

export default SectionRow
